import {AttribClass, ATTRIBUTE_CLASSES} from './../../../../../../@polygonjs/polygonjs/src/core/geometry/Constant';
import {Ref} from 'vue';
interface LocalStorageOptions {
	selectedAttribClass: Ref<AttribClass>;
}

const KEY = 'spreadsheet-selectedAttribClass';

export function SetupLocalStorage(options: LocalStorageOptions) {
	function saveToLocalStorage() {
		localStorage.setItem(KEY, options.selectedAttribClass.value);
	}

	function loadFromLocalStorage() {
		return localStorage.getItem(KEY);
	}

	const current = loadFromLocalStorage();
	if (current && ATTRIBUTE_CLASSES.includes(current as AttribClass)) {
		options.selectedAttribClass.value = current as AttribClass;
	}

	return {
		saveToLocalStorage,
		loadFromLocalStorage,
	};
}
